import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { IconButton, Tooltip } from 'shared/ui'
import { ZIndex } from 'shared/constants/zIndex'
import { type CallContact } from 'entities/Call/model/CallContact'

type IAcceptDeclineActionsProps = {
  item: CallContact
  onAccept: (item: CallContact) => void
  onDecline: (item: CallContact) => void
  acceptDisabled?: boolean
  acceptDisabledTooltip?: string
  innerRefCurrent?: HTMLDivElement
}

export const AcceptDeclineActions: FC<IAcceptDeclineActionsProps> = observer(
  ({
    item,
    onAccept,
    onDecline,
    acceptDisabled = false,
    acceptDisabledTooltip,
    innerRefCurrent,
  }) => {
    const popperProps = {
      popperOptions: {
        modifiers: [{ name: 'preventOverflow', options: { boundary: innerRefCurrent } }],
      },
    }

    const acceptButton = (
      <IconButton
        ariaLabel={'ContactCardAccept'}
        icon={'phone'}
        size={'small'}
        color={'green'}
        fontSize={16}
        disabled={acceptDisabled}
        tooltipProps={
          acceptDisabled
            ? undefined
            : {
                label: 'Accept',
                placement: 'top',
                zIndex: ZIndex.OVERLAY_TOP_1,
                PopperProps: popperProps,
              }
        }
        onClick={() => onAccept(item)}
      />
    )

    return (
      <>
        {acceptDisabled && acceptDisabledTooltip ? (
          <Tooltip
            label={acceptDisabledTooltip}
            placement={'top'}
            maxWidth={190}
            zIndex={ZIndex.OVERLAY_TOP_1}
            PopperProps={popperProps}
          >
            {acceptButton}
          </Tooltip>
        ) : (
          acceptButton
        )}
        <IconButton
          ariaLabel={'ContactCardDecline'}
          icon={'phoneHangUp'}
          size={'small'}
          color={'red'}
          fontSize={16}
          tooltipProps={{
            label: 'Decline',
            placement: 'top',
            zIndex: ZIndex.OVERLAY_TOP_1,
            PopperProps: popperProps,
          }}
          onClick={() => onDecline(item)}
        />
      </>
    )
  }
)
